<template>
	<section class="bg-color-gold-50">
		<div class="container pt-500-lg pt-400 pb-150-md pb-150-smo">
			<div v-if="appStore.isDesktop" class="display-flex justify-content-space-between px-300-md">
				<div v-for="award in awards" :key="award.title" class="display-flex">
					<span><img :src="crestImageUrl" role="presentation" alt="" class="left-crest" /> </span
					><div class="display-flex flex-direction-column align-items-center justify-content-center mx-100">
						<img
							v-lazy="award.imageUrl"
							:alt="award.imageAlt"
							:style="`height: ${award.imageHeight};width: auto`"
						/>

						<span
							class="mt-50 body-sm text-color-dark-80 text-align-center line-height-120"
							v-html="award.title"
						/> </div
					><span><img v-lazy="crestImageUrl" role="presentation" alt="" class="right-crest" /> </span>
				</div>
			</div>
			<HorizontalScroll v-else class="mt-100">
				<template #scroll-items>
					<div v-for="award in awards" :key="award.title" class="display-flex">
						<span><img v-lazy="crestImageUrl" role="presentation" alt="" class="left-crest" /> </span
						><div
							class="display-flex flex-direction-column align-items-center justify-content-center mx-150"
						>
							<img
								v-lazy="award.imageUrl"
								:alt="award.imageAlt"
								:style="`height: ${award.imageHeight};width: auto`"
							/>

							<span
								class="mt-50 body-sm text-color-dark-80 text-align-center line-height-120"
								v-html="award.title"
							/> </div
						><span><img :src="crestImageUrl" role="presentation" alt="" class="right-crest" /> </span>
					</div>
				</template>
			</HorizontalScroll>

			<p class="text-color-content-secondary body-xs mt-300 text-align-center">
				<BaseButton
					classes="link text-color-current-color text-decoration-underline"
					@click="scrollToDisclaimer"
					>Learn more</BaseButton
				>
				about rating details.</p
			>
		</div>
	</section>
</template>

<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import HorizontalScroll from '@components/wizard/horizontal-scroll.vue';
import { scrollToAnchor } from '@utils/scroll-to';
import { useAppStore } from '@stores/app';

const appStore = useAppStore();

const logosImagePrefix = `${appCloudfrontPath}/images/marketing-site/logos`;
const awards: Array<{ title: string; imageUrl: string; imageAlt: string; imageHeight: string }> = [
	{
		title: 'Best Real Estate<br/> Investing Apps',
		imageUrl: `${logosImagePrefix}/business-insider.png`,
		imageAlt: 'Business Insider logo',
		imageHeight: '30px'
	},
	{
		title: 'Fastest-Growing Private<br/> Companies in America',
		imageUrl: `${logosImagePrefix}/inc-5000.png`,
		imageAlt: 'Inc 5000 logo',
		imageHeight: '32px'
	},
	{
		title: 'Technology Fast 500',
		imageUrl: `${logosImagePrefix}/deloitte.png`,
		imageAlt: 'Deloitte logo',
		imageHeight: '19px'
	},
	{
		title: 'World’s Top 250<br/> Fintech Companies',
		imageUrl: `${logosImagePrefix}/cnbc.png`,
		imageAlt: 'CNBC logo',
		imageHeight: '30px'
	}
];
const crestImageUrl = `${appCloudfrontPath}/images/marketing-site/crest.png`;

function scrollToDisclaimer(): void {
	scrollToAnchor('awardsDisclaimers');
}
</script>
<style lang="scss" scoped>
@use '../../styles/constants/colors.scss' as *;
@use 'sass:map';

.bg-color-gold-50 {
	background-color: map.get($golds, 50);
}

.line-height-120 {
	line-height: 1.2rem;
}

.left-crest {
	height: 78px;
	width: auto;
	max-width: none;
}

.right-crest {
	height: 78px;
	width: auto;
	max-width: none;
	-webkit-transform: scaleX(-1);
	transform: scaleX(-1);
}
</style>
